import LocalizedStrings from 'localized-strings';

import { PlansVariant } from '__generated__/GQL';

export default new LocalizedStrings({
  en: {
    seeOffer: 'See offers',
    [PlansVariant.Solo]: {
      subtitle:
        'Our offers adapted to solo entrepreneurs or liberal professions.',
      title: 'Freelancers',
    },
    [PlansVariant.Team]: {
      subtitle: 'Our most complete offers especially designed for the teams.',
      title: 'TPE / Startups',
    },
  },
  fr: {
    seeOffer: 'Voir les offres',
    [PlansVariant.Solo]: {
      subtitle:
        'Nos offres adaptées aux entrepreneur·es solo ou en profession libérale.',
      title: 'Indépendant·es',
    },
    [PlansVariant.Team]: {
      subtitle:
        'Nos offres les plus complètes pour répondre aux besoins des entreprises et des équipes.',
      title: 'TPE / Startups',
    },
  },
} as const);
